export default "__VITE_ASSET__1a73c7e3__"